import { useQuery } from 'react-query';

import { httpService } from '../../../../../services/http.service';
import { BASE_URL } from '../../../../../constants/endpoints';
import { ISupplierModel } from '../../../../Supplier/types';

export const useFetchVendorById = ({ customerId, accountExternalId, supplierExternalId }: { customerId: string, accountExternalId: string, supplierExternalId: string }) => useQuery(
  'fetchVendorById',
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/supplier/${supplierExternalId}`));
    return data.supplier as ISupplierModel;
  },
  {
    refetchOnWindowFocus: false,
  },
);
